const PrincipalDesk = () => {
  
  return (
    <section className="ftco-section ftco-no-pt ftco-no-pb"> 
      <div className="container">

      <div className="row justify-content-center mt-3 pb-4">
          <div className="col-md-12  heading-section ftco-animate text px-4">
            <h2 className="mb-4 text-success text-center">
              <span className="text-warning">Principal's </span> Desk
            </h2>   
          </div>
        </div>
        <div className="row mt-3">
        <div className=" col-md-12 order-md-first ">
            <div className="text px-4">
            <p> It is my pleasure to welcome you to Kaamadhenu College of Education.</p>
<p>As the Principal of Kaamadhenu College of Education, I consider it a responsibility to uphold
academic discipline, professional standards, and reflective practices in teacher education. The
institution is committed to preparing prospective teachers who possess sound subject
knowledge, effective pedagogical skills, and a clear understanding of their professional role
in society.</p>
<p>The Bachelor of Education (B.Ed.) programme is conducted in accordance with the
curriculum and regulations prescribed by Tamil Nadu Teachers Education University. Due
emphasis is given to both theoretical understanding and practical training, including lesson
planning, teaching practice, and evaluation. Through systematic academic processes, student
teachers are guided to develop competence, confidence, and clarity in classroom instruction.</p>
<p>The faculty members of the college are dedicated to mentoring student teachers through
continuous academic guidance and constructive feedback. The institution encourages active
participation in curricular and co curricular activities that contribute to professional growth,
ethical conduct, and holistic development.</p>
<p>I encourage every student teacher to approach the programme with sincerity, discipline, and a
commitment to learning. The academic journey at Kaamadhenu College of Education should
serve as a strong foundation for responsible teaching practice and lifelong professional
development.</p>
<p>I wish all our student teachers a purposeful and successful academic journey.</p>
              <p>Warm Regards,</p>
               <h5 className='font-weight-bold text-left'>Dr. S. Ramprabhu. <br/>
               <span className="qualification">M.Sc. (Chem),M.Ed.,M.Sc.,(Psy),M.A.,(Socio),UGC-NET(Edu),Ph.D.(Edu) </span> <br /> Principal</h5>
             </div>
          </div>
        </div>  
      </div>  
      <hr className="custom-hr"/>
    </section>
  );
};

export default PrincipalDesk;
